require('./chatMembers.i18n.json');
require('./chatMembers.tpl.html');
require('./chatMembersController.js');
require('./chatMembersDropdown/chatMembersDropdownComponent');

const ChatMembersComponent = {
    templateUrl: '/collaboration/chat/chatMembers/chatMembers.tpl.html',
    controller: 'chatMembersController',
    bindings: {
        chatMembers: '<',
        hasInvitePermission:'<'
    }
};

angular.module('gw-um-submission')
    .component('uiChatMembers', ChatMembersComponent);
